<mb-section-headline
  *ngIf="agenda.title || agenda.anchor"
  [headline]="agenda.title"
  [anchor]="agenda.anchor"
  [theme]="'dark'"
></mb-section-headline>

<div class="container-sm">
  <mb-accordion
    *ngFor="let agendaDay of agendaDaysMap | keyvalue; let i = index"
    #accordion
    [hideIcon]="true"
    [isOpen]="agendaDay.value.isOpen"
    (toggled)="agendaDay.value.isOpen = $event"
  >
    <div accordion-header class="header">
      <h4>{{ 'DAY_N' | translate: { day: i + 1 } }}</h4>
      <div class="icon-container">
        <span class="mb-badge-small">{{ agendaDay.value.agendaItems.length }}</span>
        <span class="icon mb-icon mb-icon-down-thin"></span>
      </div>
    </div>
    <div accordion-content class="content">
      <div *ngFor="let agendaItem of agendaDay.value.agendaItems" class="agenda-item">
        <span class="time copy-s">{{ agendaItem.time }}</span>
        <div class="wrapper">
          <span
            class="copy-xl title"
            [style.color]="agendaItem.isTestDrive ? agendaItem.testDriveColor.color : 'inherit'"
            >{{ agendaItem.title }}</span
          >
          <span
            *ngIf="agendaItem.isTestDrive"
            class="copy-s badge"
            [style.background]="agendaItem.testDriveColor.color"
            >{{ 'TEST_DRIVE' | translate }}</span
          >
          <div class="copy-s location">
            <span *ngIf="agendaItem.icon" class="mb-icon d-none d-sm-block" [class]="agendaItem.icon"></span>
            <span class="text">{{ agendaItem.location }}</span>
          </div>
        </div>
      </div>
    </div>
  </mb-accordion>
</div>
